import { createInstance, type i18n as I18nInstance } from "i18next";
import { initReactI18next } from "react-i18next";
import type { LanguageCode } from "./site-config";

export type CommonMessages = Record<string, unknown>;

const DEFAULT_NAMESPACE = "common";

export function createI18nInstance(
  initialLanguage: LanguageCode = "en",
  commonMessages: CommonMessages = {},
): I18nInstance {
  const instance = createInstance();

  void instance
    .use(initReactI18next)
    .init({
      initAsync: false,
      fallbackLng: "en",
      lng: initialLanguage,
      debug: false,
      supportedLngs: ["en", "de", "fr", "it"],
      ns: [DEFAULT_NAMESPACE],
      defaultNS: DEFAULT_NAMESPACE,
      resources: {
        [initialLanguage]: {
          [DEFAULT_NAMESPACE]: commonMessages,
        },
      },
      interpolation: {
        escapeValue: false,
      },
      react: {
        useSuspense: false,
      },
    });

  return instance;
}

export function setLanguageMessages(
  instance: I18nInstance,
  language: LanguageCode,
  commonMessages: CommonMessages,
) {
  instance.addResourceBundle(language, DEFAULT_NAMESPACE, commonMessages, true, true);
}
